export default "__VITE_ASSET__Bnd4zGK4__"